export const TRANSLATIONS = {
  CANCEL_ORDER_SUCCESS: (orderId: string) =>
    `Successfully cancelled order ${orderId}`,
  CANCEL_ORDER_ERROR: 'Error while cancelling the order',
  CANCEL_ORDER: 'Cancel order?',
  CANCEL_ORDER_BUTTON: 'Cancel order',
  PARTIAL_REFUND: 'Partial refund',
  PARTIAL_REFUND_ERROR_NOTIFICATION: 'Error while refunding the order',
  PARTIAL_REFUND_SUCCESS_NOTIFICATION: 'Order successfully refunded',
  FULL_REFUND: 'Full refund',
  ARE_YOU_SURE_CANCEL: 'Your order will be cancelled right away.',
  ARE_YOU_SURE_REFUND: 'Are you sure you want to refund this collection order?',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  DETAILS: 'Details',
  YES: 'Yes',
  NO: 'No',
  DISABLED_CONDITIONS:
    'An order can only be cancelled if it is in the Received or Pending state',
  PARTIAL_REFUND_422_NO_REFUND_FEE:
    'There is no Refund Fee Contracted Product created to support this refund'
};

export const COLLECTIONS_CANCEL_BUTTON_TEST_ID = 'cancel-order-button';
export const COLLECTIONS_PARTIAL_REFUND_SUBMIT_BUTTON_TEST_ID =
  'partial-refund-submit-button';
export const COLLECTIONS_PARTIAL_REFUND_OPEN_MODAL_BUTTON_TEST_ID =
  'partial-refund-open-dialog-button';
export const COLLECTIONS_PARTIAL_REFUND_AMOUNT_INPUT_TEST_ID =
  'partial-refund-amount-input';
export const COLLECTIONS_FULL_REFUND_BUTTON_TEST_ID = 'full-refund-button';
